/**
 * Admin Resources page (/admin/resources): full CRUD on folders + files.
 */
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import ResourceBrowser from "../../components/resources/ResourceBrowser";

export default function AdminResources() {
  return (
    <div data-testid="admin-resources-page" className="space-y-10">
      <PortalPageHeader
        kickerKey="admin.placeholder.kicker"
        titleKey="admin.nav.resources"
        subtitleKey="admin.pages.resources_desc"
      />
      <ResourceBrowser mode="admin" />
    </div>
  );
}
